import type { HbBidderConfig } from '../types'

export const ONETAG: HbBidderConfig = {
    bidder: 'onetag',
    params: ({ type }) => ({
        pubId: '96270e85fa98b10',
        ext: { placement_name: type },
    }),
}
